import React from 'react';
import PropTypes from 'prop-types';

export default function PlayerMiniShirtIcon({ size, color, text, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 18 17" {...rest}>
      <path
        fill={color}
        d="M6.46574838,-2.13162821e-14 C5.80454838,0.1754 3.10534838,1.2197 2.67584838,1.6019 C2.55514838,1.7094 0.705948382,6.1348 0.00154838225,7.1096 C-0.0812516177,7.2424 3.18174838,8.4703 3.78784838,8.7096 L3.78784838,16.6143 L13.6062484,16.6143 L13.6062484,8.7096 C14.2123484,8.4703 17.4753484,7.2424 17.3925484,7.1096 C16.6881484,6.1348 14.8389484,1.7094 14.7182484,1.6019 C14.2887484,1.2197 11.5895484,0.1754 10.9283484,-2.13162821e-14 C10.4436484,1.839 6.95014838,1.8379 6.46574838,-2.13162821e-14 Z"
      />
      <g>
        <text
          fill="#000"
          fontFamily="CoreSansMedium"
          fontSize="8"
          fontWeight="500"
          letterSpacing="-.926"
          textAnchor="middle"
          transform="translate(5.845 8.528)"
        >
          <tspan x="2.5" y="3">
            {text}
          </tspan>
        </text>
      </g>
    </svg>
  );
}
PlayerMiniShirtIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  text: PropTypes.string,
};
PlayerMiniShirtIcon.defaultProps = {
  size: 23,
  color: '#000',
  text: '',
};
